const statisticsHu = {
    "monthly_comparison": {
        "mom": "előző hó",
        "no_data_yoy": "Nincs adat egy évvel ezelőttre.",
        "no_data_mom": "Nincs adat az előző hónapra.",
        "not_enough_history": "Legalább egy teljes lezárt hónap kell az összehasonlításhoz.",
        "load_failed": "Az adatok betöltése nem sikerült.",
        "based_on_days": "d1-d{{days}} alapján",
        "units": {
            "pcs": "db",
            "guests": "fő",
            "pp": "százalékpont",
        },
        "charts": {
            "trailing_title": "Vendégszám – 12 hónapos kontextus",
            "trailing_to_date_note": "Minden hónap értéke az első {{days}} napra szűkítve.",
            "other_months": "Többi hónap",
            "table_view": "Táblázat",
            "category": "Kategória",
            "no_data": "Nincs adat a kiválasztott hónapra.",
            "breakdown": {
                "source": "Foglalások forrás szerint",
                "status": "Foglalások státusz szerint",
                "country": "Belföldi és külföldi foglalások",
                "daypart": "Foglalások napszak szerint",
            },
        },
        "dayparts": {
            "morning": "Reggel 6–11",
            "lunch": "Ebéd 11–15",
            "afternoon": "Délután 15–18",
            "dinner": "Vacsora 18–22",
            "evening": "Este 22+",
        },
        "kpi": {
            "reservations_total": "Foglalások száma",
            "reservations_confirmed": "Megerősített foglalások",
            "guests_total": "Vendégszám",
            "avg_party_size": "Átlagos társaságméret",
            "no_show_rate": "No-show arány",
            "cancellation_rate": "Lemondás arány",
            "voucher_sold_count": "Eladott voucher (db)",
            "voucher_sold_value": "Voucher-eladás értéke",
        },
    },
    "reviews": {
        "average_score": "Átlagos értékelés",
        "review_count": "Értékelések száma",
        "rating": "Összesített",
        "food_rating": "Étel",
        "service_rating": "Kiszolgálás",
        "atmosphere_rating": "Hangulat",
        "text_rating": "Szöveges értékelés",
        "stars": "{{count}} csillag",
        "detailed_report_title": "Részletes riport",
        "detailed_report_subtitle": "Egyéni dátumintervallum",
        "trends": {
            "section_title": "Trend áttekintés",
            "section_subtitle": "Elmúlt 6 hónap vagy elmúlt év, egy pillantásra",
            "rating_trend_title": "Átlagos értékelések alakulása",
            "review_count_title": "Értékelések száma az idő során",
            "monthly": "Havi",
            "weekly": "Heti",
            "last_year": "Elmúlt év",
            "last_6_months": "Elmúlt 6 hónap",
        },
    },
}

export default statisticsHu;
